import { format, parse } from 'date-fns';
import { FormikValues } from 'formik';
import { TAppointment } from '@api/appointments/types';

type BlackoutResult = {
  conflictedAppointments: TAppointment[];
};

type BlackoutFunction = (values: any) => {
  unwrap: () => Promise<{ success: number; message: string; data: BlackoutResult }>;
};

export const processBlackoutResult = async (
  values: any,
  blackoutFunction: BlackoutFunction,
  closeModal: () => void,
) => {
  const formattedBlackout = {
    ...values,
    from: format(values.from, 'yyyy-MM-dd'),
    to: format(values.to, 'yyyy-MM-dd'),
  };

  const { success, message, data } = await blackoutFunction(formattedBlackout).unwrap();

  if (success === 1) {
    closeModal();
    return {
      success,
      message,
    };
  }

  if (success === 0) {
    return {
      success,
      message,
    };
  }

  if (success === 2) {
    return {
      success,
      message,
      data,
    };
  }

  throw new Error(message);
};

export const normalizeDateInput = (dateValue: string | Date) => {
  if (dateValue instanceof Date) {
    return dateValue;
  }

  const parsedDate = parse(dateValue, 'MM/dd/yyyy', new Date());

  return parsedDate;
};

export const formatFormValues = (formValues: FormikValues) => ({
  ...formValues,
  from: normalizeDateInput(formValues.from),
  to: normalizeDateInput(formValues.to),
});
